import { subscribeChannel, publishChannel } from './channelUtils';

export function sendOpenMap({modeMap, codigoMap, tripData}) {
    
    publishChannel('map-open', {modeMap, codigoMap, tripData});

}

export function sendCloseMap() {
    
    publishChannel('map-close');

}

export function sendLoadingMap(loadingMap){
    publishChannel('map-loading', loadingMap);
}

export function sendRoute(data) {
    publishChannel('map-route', data);
}

export function sendTrajeto(data) {
    publishChannel('map-trajeto', data);
}

export function sendSelectedPoint(ponto) {
    publishChannel('map-point', ponto);
}

export function sendMapFocus(mapFocus) {
    publishChannel('map-focus', mapFocus);
}

export function sendPositionsRange(positionsRange) {
    publishChannel('map-positions-range', positionsRange);
}

export function sendClearPositionsRange() {
    publishChannel('map-clear-positions-range');
}

export function sendLastPosition(lastPosition){
    publishChannel('map-last-position', lastPosition);
}

export function sendClearLastPosition(){
    publishChannel('map-clear-last-position');
}

export function sendAppendPositionRange(position) {
    publishChannel('map-append-positions-range', position);
}

export function listenMap(callback) {

    return subscribeChannel((event) => {

        const { tipo, payload } = event.data;

        if (
            tipo !== 'map-open' &&
            tipo !== 'map-close' &&
            tipo !== 'map-loading' &&
            tipo !== 'map-route' &&
            tipo !== 'map-trajeto' &&
            tipo !== 'map-point' &&
            tipo !== 'map-focus' &&
            tipo !== 'map-positions-range' &&
            tipo !== 'map-clear-positions-range' &&
            tipo !== 'map-last-position' &&
            tipo !== 'map-clear-last-position' &&
            tipo !== 'map-append-positions-range'
        ) {
            return;
        }

        callback({ tipo, payload });

    });

}